export default {
	addPerson: "Add Person",
	confirmRemovePerson: "Are you sure you want to remove this person?",
	editPerson: "Edit Person",
	errorActivatingPerson: "Error activating person",
	errorDeactivatingPerson: "Error deactivating person",
	errorLoadingAvailablePersons: "Error loading available persons",
	errorLoadingPersons: "Error loading persons",
	errorRemovingPerson: "Error removing person",
	errorSavingPerson: "Error saving person",
	person: "Person",
	personActivatedSuccess: "Person activated successfully",
	personAddedSuccess: "Person added successfully",
	personDeactivatedSuccess: "Person deactivated successfully",
	personRemovedSuccess: "Person removed successfully",
	personUpdatedSuccess: "Person updated successfully",
};
